import hamburger from "./others/_hamburger.js";
import searchMenu from "./others/_search-menu.js";
import toggle from "./others/_toggle.js";
import cardsEstate from "./cards/_estate.js";
import othersSearchList from "./others/_search-list.js";
import othersSelectSearch from "./others/_select-search.js";
import buttonsShare from "./buttons/_share.js";
import buttonsFavorite from "./buttons/_favorite.js";
import formsSelect from "./forms/_select.js";
import footerSearch from "./others/_footer-search.js";
import otherHeadAlert from "./others/_head-alert.js";
import blockLifestyle from "./others/_block-lifestyle.js";
import formsInputCalendar from "./forms/_input-calendar.js";
import lpViewingSchedule from "./sections/_lp-viewing-schedule.js";
import loanSimulation from "./others/_loan-simulation.js";
import topSectionBanner from "./others/_top-section-banner.js";
import areaEstateRecommend from "./others/_area-estate-recommend.js";
import othersSliderDots from "./others/_slider-dots.js";
import othersToc from "./others/_toc.js";
import formsSortDropdown from "./forms/_sort-dropdown.js";
import layoutHeaderVersion from "./layout/_header-version.js";
import blockAreaSearch from "./others/_block-area-search.js";
import storeGallery from "./others/_store-gallery.js";
import storeMapModal from "./others/_store-map-modal.js";
import buildAreaModal from "./others/_build-area-modal.js";
import sellConsultModal from "./others/_sell-consult-modal.js";
import formsRowAreaShop from "./forms/_row-area-shop/index.js";

const syncHeaderHeight = () => {
    const header = document.querySelector('.l-header');
    if (!header) return;
    const update = () => {
        document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);
    };
    update();
    window.addEventListener('resize', update, { passive: true });
};

const components = () => {
    syncHeaderHeight();
    hamburger();
    searchMenu();
    toggle();
    cardsEstate();
    othersSearchList();
    othersSelectSearch();
    buttonsShare();
    buttonsFavorite();
    formsSelect();
    footerSearch();
    otherHeadAlert();
    blockLifestyle();
    formsInputCalendar();
    lpViewingSchedule();
    loanSimulation();
    topSectionBanner();
    areaEstateRecommend();
    othersSliderDots();
    othersToc();
    formsSortDropdown();
    layoutHeaderVersion();
    blockAreaSearch();
    storeGallery();
    storeMapModal();
    buildAreaModal();
    sellConsultModal();
    formsRowAreaShop();
};

export default components;
